import React from 'react'
// import config from '../../config'
import format from '../../helpers/format'
// import { Link, LinkIcon } from '../'

const EsgConfig = {
  esgNamesLabels: [
    {
      label: 'Overall exposure',
      value: 't_all_weight',
    },
    {
      label: 'Tobacco producers',
      value: 'to_weight',
    },
    {
      label: 'Tobacco-promoting entertainment companies',
      value: 'tm_weight',
    }
  ],
  esgOptions: {
    t_all_weight: {
      id: 't_all_weight',
      icon: 'icons_step4',
      fieldLabel: 't_all_weight',
      benchLabel: 't_all_weight',
      valueLabel: 'Overall exposure',
      direction: 'ascending',
      page: 'all-company-investments',
      label: 'in tobacco and tobacco-promoting entertainment companies',
      units: null,
      unitsExpanded: null,
      diffGood: (diff) => (diff < 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-bad' : 'lower-good',
      moreLess: (diff) => (diff > 0) ? 'More invested' : 'Less invested',
      format : (val) => format.perc(val),
      formatExpanded: (val, moreLess, postiveNegative, url) => {
        if (val === 0) {
          return (
            <span>
              <strong>the same amount</strong> invested in tobacco and tobacco-promoting entertainment companies
            </span>
          )
        }
        return (
          <span>
            <strong styleName={postiveNegative}>{format.perc(val)} {moreLess}</strong> invested in tobacco and tobacco-promoting entertainment companies
          </span>
        )
      }
    },
    to_weight: {
      id: 'to_weight',
      icon: 'icons_step4',
      fieldLabel: 'to_weight',
      benchLabel: 'to_weight',
      valueLabel: 'Tobacco producers',
      direction: 'ascending',
      page: 'tobacco-company-investments',
      label: 'in tobacco producers',
      units: null,
      unitsExpanded: null,
      diffGood: (diff) => (diff < 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-bad' : 'lower-good',
      moreLess: (diff) => (diff > 0) ? 'More invested' : 'Less invested',
      format : (val) => format.perc(val),
      formatExpanded: (val, moreLess, postiveNegative, url) => {
        if (val === 0) {
          return (
            <span>
              <strong>the same amount</strong> invested in tobacco producers
            </span>
          )
        }
        return (
          <span>
            <strong styleName={postiveNegative}>{format.perc(val)} {moreLess}</strong> invested in tobacco producers
          </span>
        )
      }
    },
    tm_weight: {
      id: 'tm_weight',
      icon: 'icons_step4',
      fieldLabel: 'tm_weight',
      benchLabel: 'tm_weight',
      valueLabel: 'Tobacco-promoting entertainment companies',
      direction: 'ascending',
      page: 'entertainment-company-investments',
      label: 'in tobacco-promoting entertainment companies',
      units: null,
      unitsExpanded: null,
      diffGood: (diff) => (diff < 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-bad' : 'lower-good',
      moreLess: (diff) => (diff > 0) ? 'More invested' : 'Less invested',
      format : (val) => format.perc(val),
      formatExpanded: (val, moreLess, postiveNegative, url) => {
        if (val === 0) {
          return (
            <span>
              <strong>the same amount</strong> invested in tobacco-promoting entertainment companies
            </span>
          )
        }
        return (
          <span>
            <strong styleName={postiveNegative}>{format.perc(val)} {moreLess}</strong> invested in tobacco-promoting entertainment companies
          </span>
        )
      }
    }
  }
}

export default EsgConfig